import { render, staticRenderFns } from "./grid-sidebar.vue?vue&type=template&id=649f6daa&scoped=true&"
import script from "./grid-sidebar.vue?vue&type=script&lang=js&"
export * from "./grid-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./grid-sidebar.vue?vue&type=style&index=0&id=649f6daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f6daa",
  null
  
)

export default component.exports